<div
  dotHtmlReady
  (htmlReady)="onHtmlReady()"
  #emContainer
  [class]="content?.contentId"
  [ngStyle]="ngStyles"
></div>

<!-- TODO: Discuss how to implement the error Status -->
<!-- <div *ngIf="(iframeStatus$ | async) === 'error'">
  <p>Something Went Wrong</p>
</div> -->
